import { filterFieldStyleTags } from '../decorations/highlight.js';
import { parser } from './parser.js';

/** @internal */
export const filterFieldParser = parser.configure({
  props: [filterFieldStyleTags],
});
